export const isDev = process.env.NODE_ENV === 'development';
export const isStaging = process.env.VUE_APP_IS_STAGING === 'true';
export const base =
    isDev ? 'https://localhost:6001/'
        : isStaging
        ? 'https://appls.ncut.edu.tw/fakencutuni/'
        : 'https://ncutuni.ncut.edu.tw/';
export const SystemKey = 'd775a3c6b5594741bdce608931488290';
export const TOKEN_KEY = `jwt_${SystemKey}`;
export const app_name = process.env.VUE_APP_TITLE;
export const Semesters = [
    {
        text: '上學期',
        value: 1,
    },
    {
        text: '下學期',
        value: 2,
    },
    {
        text: '暑修1',
        value: 3,
    },
    {
        text: '暑修2',
        value: 4,
    },
    {
        text: '寒修',
        value: 5,
    }
];

export const IdentityTypes = {
    Employee: '0',
    Student: '1',
    Teacher: '2'
};

export const Weekdays = [
  '日','一', '二', '三', '四', '五', '六', '日'
];

